import { useMutation } from "@tanstack/react-query";
import {useNavigate} from "react-router-dom";

const signup = async (userData) => {

    try {
        const response = await fetch("/api/signup", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(userData),
        });

        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || "회원가입에 실패했습니다.");
            }
            return data;
        } else {
            const text = await response.text();
            console.error("Unexpected response:", text);
            throw new Error("서버에서 예상치 못한 응답을 받았습니다.");
        }
    } catch (error) {
        console.error("Signup error:", error);
        throw error;
    }
};

const verifyPhone = async ({ phoneNumber }) => {
    const response = await fetch("/api/members/phone/certification/no-user", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ phoneNumber }),
    });

    const data = await response.json();
    console.log(response.ok ? "전화번호 인증 요청 성공" : "전화번호 인증 요청 실패", data);
    if (data.result === "duplicate") {
        throw new Error(data.message || "이미 가입된 회원입니다.");
    }
    if (!response.ok) {
        throw new Error(data.message || "전화번호 인증 요청에 실패했습니다.");
    }

    return data;
};

export const useSignupMutation = () => {
    var navigate = useNavigate();

    return useMutation({
        mutationFn: signup,
        onSuccess: (data) => {
            console.log("회원가입 성공:", data);
            // 회원가입 성공 시 쿠폰 발급 알림 표시
            if (data && data.data) {
                // alert("회원가입이 완료되었습니다. 가입 축하 쿠폰이 발급되었습니다!");
            }
        },
        onError: (error) => {
            console.error("회원가입 실패:", error);

            // 사용자에게 에러 메시지 표시
            if (error.message.includes("이미 가입된 회원입니다.")) {
                alert("이미 가입된 회원입니다. 로그인해주세요.");
                navigate("/login");
            }
            else if (error.message.includes("인증 시간이 초과되었습니다.")) {
                alert("인증 시간이 초과되었습니다. 다시 시도해주세요 요청해주세요.");
                navigate("/signup");
            } else if (error.message.includes("인증을 완료해야 회원가입이 가능합니다.")) {
                alert("인증번호가 일치하지 않습니다. 다시 확인해주세요.");
            }

            throw error;
        },
    });
};

export const useVerifyPhoneMutation = () => {
    var navigate = useNavigate();
    return useMutation({
        mutationFn: verifyPhone,
        onSuccess: (data) => {
            console.log("전화번호 인증 요청 성공:", data);
        },
        onError: (error) => {
            console.error("전화번호 인증 요청 실패:", error);

            if (error.message.includes("이미 가입된 회원입니다.")) {
                alert("이미 가입된 회원입니다. 로그인해주세요.");
                navigate("/login");
            }
            else if (error.message.includes("인증 시간이 초과되었습니다.")) {
                alert("인증 시간이 초과되었습니다. 다시 시도해주세요.");
                navigate("/signup");
            } else if (error.message.includes("인증을 완료해야 회원가입이 가능합니다.")) {
                alert("인증번호가 일치하지 않습니다. 다시 확인해주세요.");
            }

            throw error;
        },
    });
};
